<template>
  <div class="app">
    <div><head1></head1></div>
    <div class="banner">
      <div class="l-banner">
        <img src="@/assets/images/list_banner.jpg" alt="" width="100%" />
      </div>
      <div class="banner-title">
        <h1>人才引进</h1>
        <div class="banner_title_line"></div>
      </div>
    </div>
    <div class="bread-nav">
      <span>您的位置：</span>
      <span @click="home()" class="nav-item">首页</span>
      <span class="possplit"></span>
      <span class="nav-item" @click="jtjs()">人才引进</span>
      <span class="possplit" v-if="index1 == 1"></span>
      <span v-if="index1 == 1">培训发展</span>
      <span class="possplit" v-if="index1 == 2"></span>
      <span v-if="index1 == 2">工作机会</span>
    </div>
    <div class="mgb80">
      <div class="content-web">
        <div class="left_nav">
          <div class="left_nav_title">
            <h1>人才引进</h1>
            <div class="left_nav_line"></div>
          </div>
          <div class="col_menu_con">
            <div class="col_list">
              <el-menu
                default-active="2"
                @select="handleSelect1"
                class="el-menu-vertical-demo"
                background-color="#023A8F"
                text-color="#fff"
                active-text-color="#206BD1"
              >
                <el-menu-item index="1">
                  <span slot="title" :class="index1 == 1 ? 'activeColor' : ''"
                    >培训发展</span
                  >
                </el-menu-item>
                <el-menu-item index="2">
                  <span slot="title" :class="index1 == 2 ? 'activeColor' : ''"
                    >工作机会</span
                  >
                </el-menu-item>
              </el-menu>
            </div>
          </div>
        </div>
        <div class="inner_content_right">
          <pxfz v-if="index1 == 1"></pxfz>
          <gzjh v-if="index1 == 2"></gzjh>
        </div>
      </div>
    </div>

    <div class="footer">
      <foot></foot>
    </div>
    <div class="footer-bottom">
      <bottom></bottom>
    </div>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import pxfz from "./pxfz.vue";
import gzjh from "./gzjh.vue";
import foot from "../footer.vue";
import bottom from "../bottom.vue";
import head1 from "../head.vue";
export default {
  name: "App",
  components: {
    // HelloWorld
    gzjh,
    head1,
    pxfz,
    foot,
    bottom,
  },
  data() {
    return {
      images: [
        { id: 1, url: require("@/assets/images/1.png"), qq: "水电费水电费" },
        { id: 2, url: require("@/assets/images/2.png"), qq: "而威尔" },
        { id: 3, url: require("@/assets/images/4.png"), qq: "水电费是的" },
      ],
      index: "1",
      index1: "1",
      radio1: "overview",
      currentPage4: 4,
    };
  },
  watch: {
    $route: {
      handler: function (newValue) {
        this.index1 = newValue.query.index1;
      },
    },
    deep: true,
    search: {
      handler: function (newValue, oldValue) {
        console.log(newValue, oldValue);
        if (this.index1 == 1) {
          this.getDjgzList();
        } else {
          this.getXxydList();
        }
      },
      deep: true,
    },
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    jtjs() {
      this.index1 = 1;
    },
    handleSelect1(key) {
      this.index1 = key;
    },
    jtjj() {
      this.$router.push("/147");
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    home() {
      this.$router.push("/");
    },
  },

  created() {
    this.index1 = this.$route.query.index1;
  },
};
</script>

<style lang="scss">
.activeColor {
  color: #206bd1 !important;
}
.el-menu.el-menu--horizontal {
  display: flex;
  justify-content: center;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  font-size: 16px;
  width: 180px;
  text-align: center;
}
.el-menu--horizontal > .el-menu-item:first-child {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.el-menu-item {
  width: 180px;
  text-align: center;
}
.el-menu--popup .el-menu-item {
  min-width: 0px !important;
}
.el-menu--popup .el-menu-item:hover {
  border-left: 0px !important;
}
.app {
  background-color: #f3f3f3;
}
.nav-item {
  cursor: pointer;
}
.test1 {
  background-color: #fff !important;
  color: #004aba !important;
  font-weight: 400;
  width: 200px;
  height: 100%;
  font-size: 16px;
  margin: 9px -10px;
  text-align: center;
}

.test {
  border: none !important;
  .el-menu {
    width: 180px;
    background-color: rgba(255, 255, 255, 0.85) !important;
    .el-menu-item {
      background-color: #fff !important;
      color: #004aba !important;
      font-weight: 400;
      width: 90%;
      height: 30px !important;
      font-size: 16px;
      margin: 5px 9px;
      text-align: center;
    }
  }
}
.banner {
  position: relative;
  width: 100%;
  height: 350px;
  z-index: 99;
  .l-banner {
    height: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    text-align: center;
    margin: 0 auto;
    background-size: cover;
    width: 100%;
    overflow: hidden;
    img {
      height: 326%;
      position: relative;
      top: -393px;
    }
  }
  .banner-title {
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -600px;
    box-sizing: border-box;
    padding-left: 41px;
    padding-top: 25px;
    width: 1200px;
    height: 110px;
    background-color: rgba(255, 255, 255, 0.8);
    h1 {
      font-size: 28px;
      color: #333;
    }
    .banner_title_line {
      width: 108px;
      height: 3px;
      margin: 3px 0;
      background-color: #88cc2f;
    }
  }
}
.bread-nav {
  width: 1200px;
  margin: 25px auto 0 auto;
  font-size: 14px;
  color: #666;
  span {
    margin-right: 20px;
  }
  .possplit {
    position: relative;
    top: 3px;
    display: inline-block;
    margin: 0 10px;
    width: 1px;
    height: 16px;
    background-color: #acacac;
    background-image: none;
    margin-right: 20px;
  }
}
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;
  .content-web {
    .el-menu {
      background-color: #fff !important;
    }
    .el-menu-item {
      width: 220px !important;
      background-color: #fff !important;
      font-size: 16px !important;
      color: #666 !important;
      border-bottom: 1px solid #f3f3f3;
      // padding-top: 15px !important;
      // padding-bottom: 15px !important;
      // padding-left: 15px !important;
    }
    display: flex;
    width: 1200px;
    // min-width: 1200px;
    margin: 0 auto;
    .left_nav {
      margin-right: 20px;
      height: 100%;
      display: inline;
      float: left;
      width: 220px;
      background-color: #fff;
      .left_nav_title {
        box-sizing: border-box;
        padding: 23px 20px 18px 40px;
        background-color: #206bd1;
        h1 {
          font-size: 22px;
          color: #fff;
        }
        .left_nav_line {
          height: 1px;
          background-color: #fff;
          opacity: 0.2;
          margin-top: 8px;
          margin-bottom: 5px;
        }
      }
      .left_nav_list {
        cursor: pointer;
        box-sizing: border-box;
        padding: 0 10px 20px 10px;
        .left_nav_item {
          box-sizing: border-box;
          padding-top: 15px;
          padding-bottom: 15px;
          padding-left: 15px;
          border-bottom: 1px solid #f3f3f3;
        }
      }
      .select1 {
        color: #206bd1;
      }
      .li1::before {
        position: relative;
        left: -8px;
        top: 4px;
        width: 4px;
        content: "";
        background-color: #206bd1;
        height: 21px;
        display: inline-block;
      }
      // .left_nav_item:hover {
      //   color: #206bd1;
      //   border-left: 1px solid red;
      // }
      // .select2::afte:hover {
      //   position: relative;
      //   left: -8px;
      //   top: 4px;
      //   width: 200px;
      //   content: "";
      //   background-color: #206bd1;
      //   height: 21px;
      //   display: inline-block;
      // }
    }
    .inner_content_right {
      .block {
        margin: -45px 0 20px 0;
        text-align: center;
      }
      // float: right;
      box-sizing: border-box;
      width: 960px;
      min-height: 600px;
      // margin-left: 20px;
      background-color: #fff;
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;
        .head {
          // border-bottom: 1px #444 dashed;
          // height: 500px;
        }
      }
      .text {
        text-indent: 45px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
.fwl {
  margin-left: 140px;
}
.jicon {
  background: url(@/assets/images/icon-ba.png) no-repeat center left;
  padding-left: 12px;
}
// ::v-deep .el-menu--popup {
//   display: flex;
//   flex-wrap: wrap;
//   width: 850px !important;
//   background-color: #2d68c1 !important;
// }
.footer-bottom {
  height: 50px;
  min-width: 1200px;
  background-color: #424242;
}
.footer-bottom-con {
  width: 1200px;
  height: 50px;
  margin-left: 464px;
}
.footer-bottom-con span {
  font-size: 14px;
  color: #fff;
  line-height: 50px;
  padding-right: 10px;
}
.footer-bottom-con span a {
  text-decoration: none;
  font-size: 14px;
  color: #fff;
  line-height: 50px;
  padding-right: 10px;
}
.tjlyjt {
  text-align: center;
  margin-top: 14px;
  font-size: 14px;
  color: #fff;
}
.line {
  width: 100%;
  height: 1px;
  margin: 17px 0;
  background-color: rgba(255, 255, 255, 0.3);
}
.footer-inner-right {
  margin-left: 50px;
  width: 310px;
}
.footer-inner-right-con {
  display: flex;
  margin-top: 40px;
}
.footer-inner-right-con-li {
  margin-right: 35px;
}
.footer-inner-con {
  width: 310px;
}
.footer-inner-one {
  display: flex;
  align-items: center;
}
.footer-inner-left {
  margin-right: 50px;
  width: 310px;
}
.footer-inner-left-tit {
  /* position: absolute;
  left: 0;
  top: 8px; */
  margin-right: 10px;
  content: "";
  display: block;
  width: 10px;
  height: 10px;
  background-color: #00eb9b;
}
.footer-inner-left-title {
  font-size: 18px;
  color: #fff;
}
.footer-inner-left-title2 {
  color: #fff;
  font-size: 16px;
  margin-top: 18px;
}
.footer-inner-left-title1 a {
  color: #fff;
  font-size: 16px;
  text-decoration: none;
  cursor: pointer;
}
.footer-inner {
  display: flex;
  padding-top: 30px;
  margin-left: 462px;
}
.footer-con {
  height: 280px;
  min-width: 1200px;
  background-color: #004aba;
}
.footer-nav {
  height: 51px;
  min-width: 1200px;
  background-color: #023a8f;
  .cyqy {
    width: 850px;
  }
}
.transtion {
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
}
.fl {
  margin-right: 20px;
  width: 159px;
  height: 158px;
  background: rgba(0, 108, 255, 0.45);
  cursor: pointer;
}
.industry {
  width: 100%;
  height: 250px;
  margin-top: 36px;
  position: relative;
  padding-top: 25px;
  margin-bottom: 35px;
  background: url(@/assets/images/industry.png) no-repeat;
  background-size: 100% 100%;
}
.more {
  float: right;
  margin-top: 34px;
}
.pic-info {
  top: -60px;
  position: relative;
  z-index: 99;
  bottom: 0;
  line-height: 60px;
  background: rgba(51, 51, 51, 0.6);
  width: 96%;
  font-size: 18px;
  color: #fff;
  padding: 0 2%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mor-btn {
  /* width: 175.88px; */
  cursor: pointer;
  text-align: center;
  line-height: 36px;
  background: #f7f7f7;
  color: #919493;
  padding: 0 50px;
  /* display: inline-block; */
}
.li-content {
  display: flex;
}
.list-title {
  float: left;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 80%;
}
.list-title a {
  color: #919493;
  display: inline;
  text-decoration: none;
}
.news_list {
  width: 570px;
  height: 330px;
}
.news-title {
  line-height: 54px;
  border-bottom: 1px solid #ccc;
  font-size: 16px;
  color: #919493;
}
.left {
  width: 600px;
}
.right {
  margin-left: 30px;
}
.select:hover {
  background: url(@/assets/images/select.png) no-repeat;
  padding-bottom: 10px;
  color: #fff;
}
.li-radio {
  display: flex;
  justify-content: center;
  height: 45px;
  margin-bottom: 25px;
}
.li-radio li {
  text-align: center;
  display: inline-block;
  background: #f1f1f9;
  margin: 0 6px;
  font-size: 20px;
  width: 177px;
  line-height: 40px;
  height: 40px;
}
.title {
  margin-bottom: 50px;
}
.a-title {
  color: #970f11;
  text-decoration: none;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
::v-deep .el-carousel__indicators {
  z-index: 0 !important;
}
.logo-content {
  margin: 20px 0 20px 0;
  display: flex;
  justify-content: space-around;
  /* width: 1200px; */
  /* height: 100px; */
  /* line-height: 100px; */
  text-align: center;
}
</style>
